//local
// const BASE_URL = "http://192.168.7.19:5001/node-api/";
// const DEFAULT_KEY = '54518b1c-ec6a-4b1b-ad9c-e38a6a9d9bd5'

//demo
// const BASE_URL = "https://admin.harry.iossmlm.com/node-api/";
// const DEFAULT_KEY = '54518b1c-ec6a-4b1b-ad9c-e38a6a9d9bd5'

//live
const BASE_URL = "https://admin.myaccount.network/node-api/";
const DEFAULT_KEY = 'dd49b690-8445-4bc8-9c95-0b5e2e7a917d'



const PAYPAL_CLIENT_ID = "Ad077-Gx8stGcfWQYawBiQUc4UbKWIRIg_PK4lHL4pzHR-uOPMz2vCk_jQ8QU9pcEw0j8U3UYDrEUS75"

export { BASE_URL, DEFAULT_KEY, PAYPAL_CLIENT_ID }
